import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgDownloadThickBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M8.616 1.741A1.455 1.455 0 0 1 10.07.287h3.392a1.455 1.455 0 0 1 1.453 1.454v8.228a.25.25 0 0 0 .25.25h2.9a1.138 1.138 0 0 1 .827 2l-6.1 6.1a1.49 1.49 0 0 1-2.056 0l-6.1-6.1a1.137 1.137 0 0 1 .827-2h2.9a.25.25 0 0 0 .25-.25Z"
      fill="currentColor"
    />
    <path
      d="M0 19.677a4.04 4.04 0 0 0 4.035 4.035h15.93A4.04 4.04 0 0 0 24 19.677V17.8a1.225 1.225 0 0 0-2.449 0v1.874a1.59 1.59 0 0 1-1.586 1.586H4.035a1.59 1.59 0 0 1-1.586-1.586V17.8A1.225 1.225 0 0 0 0 17.8Z"
      fill="currentColor"
    />
  </svg>
);
